import { Routes, Route } from "react-router-dom";
import Home from "../pages/Home";
import Login from "../pages/Login/";
import AddNotice from "../pages/AddNotice";
import NoticeManager from "../pages/NoticeManager";
import EditNotice from "../pages/EditNotice";
import UserManager from "../pages/UserManager";
import FirstLogin from "../pages/FirstLogin";

export default function BrowseRoutes() {
	return (
		<Routes>
			<Route path="/" element={<Home />} />
			<Route path="/login" element={<Login />} />
			<Route path="/login/firstaccess/:userid" element={<FirstLogin />} />
			<Route path="/addNotice" element={<AddNotice />} />
			<Route path="/noticeManagement" element={<NoticeManager />} />
			<Route path="/noticeManagement/editNotice/:id" element={<EditNotice />} />
			<Route path="/userManagement" element={<UserManager />} />
		</Routes>
	);
}
